module.exports = __webpack_public_path__ + "static/media/login.7c57ad7f.svg";